module.exports = __webpack_public_path__ + "9267f5027af7df7ea3be6cd62d5a598e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/game-controller.png
// module id = 2390
// module chunks = 0